import { useToastStore } from '../stores/toast_store';
export const useToast = () => {
    const showToast = useToastStore((state) => state.showToast);
    const hideToast = useToastStore((state) => state.hideToast);
    const pendingToasts = useToastStore((state) => state.pendingToasts);
    const flushPendingToasts = useToastStore((state) => state.flushPendingToasts);
    const enqueuePendingToast = useToastStore((state) => state.enqueuePendingToast);
    return { showToast, hideToast, pendingToasts, flushPendingToasts, enqueuePendingToast };
};
